module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./FileSeeView.js"));
	}, "FileSeeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FileSeeView!./src/pages/FileSee/FileSeeView.js
// module id = 1793
// module chunks = 418